<markant-platform-simple-widget-with-action>
  <span slot="widget-headline">{{ serviceVariant()?.name }}</span>
  <span slot="widget-text-title">{{
    'platformWidget.reassignServiceRoles.descriptionTitle' | transloco
  }}</span>
  <span slot="widget-text-body">{{
    'platformWidget.reassignServiceRoles.description' | transloco
  }}</span>
  @if (buttonConfig) {
    <markant-button
      (click)="buttonConfig.action()"
      slot="widget-button"
      variant="clear"
    >
      {{ buttonConfig.label }}</markant-button
    >
  }
</markant-platform-simple-widget-with-action>
